export default __webpack_public_path__ + "static/media/techblog.1a72db65.png";